// extracted by mini-css-extract-plugin
module.exports = {"element":"sortable-elements_element__1aseD","sorter":"sortable-elements_sorter__1CkuN","action":"sortable-elements_action__38tEQ","formitem":"sortable-elements_formitem__1SvTT"};